import React from 'react';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Text } from '@lifeomic/chroma-react/components/Text';

type DeleteModalProps = {
  isOpen: boolean;
  title: string | undefined;
  onDismiss: () => void;
  onConfirm: () => void;
};

const useStyles = makeStyles(theme => ({
  deleteModalActivityTitle: {
    color: theme.palette.text.hint,
    fontSize: theme.typography.subtitle1.fontSize,
  },
}));

const messages = defineMessages({
  deleteModalTitle: {
    id: 'actionPlan.actionActivity.deleteModalTitle',
    defaultMessage: 'Delete activity?',
  },
  cancel: {
    id: 'actionPlan.actionActivity.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'actionPlan.actionActivity.delete',
    defaultMessage: 'Delete',
  },
  deleteText: {
    id: 'actionPlan.actionActivity.deleteText',
    defaultMessage: 'Are you sure you want to delete this activity?',
  },
});

export const DeleteModal = ({
  onConfirm,
  onDismiss,
  isOpen,
  title,
}: DeleteModalProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  return (
    <Modal
      isOpen={isOpen}
      title="Delete Activity"
      onDismiss={onDismiss}
      actions={
        <>
          <Button onClick={onDismiss} variant="text">
            {formatMessage(messages.cancel)}
          </Button>
          <Button onClick={onConfirm} color="negative">
            {formatMessage(messages.delete)}
          </Button>
        </>
      }
    >
      <Text>{formatMessage(messages.deleteText)}</Text>
      <Text className={classes.deleteModalActivityTitle}>{title}</Text>
    </Modal>
  );
};
